
import type { IconProps } from 'src/types/icons';

interface ModalCloseIconProps extends IconProps {
  strokeColor?: string;
}

const ImageSliderModalClose = (props: ModalCloseIconProps) => {
  const { strokeColor } = props;
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke={strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ImageSliderModalClose;
